import {BackendModule} from '../types';
import {BackendConfig} from '../../config/BackendConfig';
import {IAuthService} from '../../services/auth/AuthService';
import {DataClientService} from '../../services/data/DataClientService';
import {IStorageService} from '../../services/storage/StorageService';
import {IEventService} from '../../services/events/EventService';
import {WsServerConnection} from '../../../stores/serverConnection/wsServerConnection';
import {MockAuthService} from './MockAuthService';
import {MockWsServerConnection} from './MockWsServerConnection';
import {installMockFetch, MOCK_ENDPOINT} from './mockFetch';
import {createMockStorageService} from './mockStorage';
import {seedIfNeeded} from './scenarios';

function ensureMockConfig(config: BackendConfig) {
    if (config.type !== 'mock') {
        throw new Error(`Mock backend received unsupported config type: ${config.type}`);
    }
}

const mockBackend: BackendModule = {
    type: 'mock',
    bootstrap(config) {
        ensureMockConfig(config);
        installMockFetch();
        seedIfNeeded();
    },
    createAuthService(config): IAuthService {
        ensureMockConfig(config);
        return new MockAuthService();
    },
    createDataClientService(config): DataClientService {
        ensureMockConfig(config);
        return new DataClientService({
            defaultKey: 'pgServer',
            clients: [
                // No wsClientFactory: realtime sync is a no-op in mock mode —
                // there's exactly one local user, nothing to sync from.
                {key: 'pgServer', httpEndpoint: MOCK_ENDPOINT},
            ],
        });
    },
    createStorageService(config): IStorageService {
        ensureMockConfig(config);
        return createMockStorageService();
    },
    createEventService(config): IEventService {
        ensureMockConfig(config);
        return {
            async publish() {},
            async subscribe() {
                return {async unsubscribe() {}};
            },
            async scheduleJob() {
                return 'mock-job';
            },
            async cancelJob() {},
        };
    },
    createWsServerConnection(_authService: IAuthService): WsServerConnection {
        return new MockWsServerConnection(_authService);
    },
};

export default mockBackend;
